<template>
    <router-view v-slot="{ Component }">
        <component
            v-if="integration"
            :is="Component"
            :integration="integration"
            @update:integration="updateIntegration"
        >
        </component>
    </router-view>
</template>
<script>
import { httpClient } from '../../../services/HttpClient';
import MessageNotificator from '../../../services/MessageNotificator';

export default {
    name: "IntegrationEditPage",
    data() {
        return {
            integration: null
        };
    },
    methods: {
        updateIntegration(request) {
            httpClient.patch(`/projects/${this.$route.params.projectUuid}/pim/channels/${this.integration.uuid}`, request).then((response) => {
                this.integration = response.data.data
                new MessageNotificator().success(translate('alerts.success'))
            })
        },
        fetchIntegration(integrationUuid) {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/pim/channels/${integrationUuid}`).then((response) => {
                this.integration = response.data.data
            })
        },
    },
    async mounted() {
        this.fetchIntegration(this.$route.params.integrationUuid)
    }
}
</script>
